import React from 'react'
import styled, { keyframes } from 'styled-components'
import ReactDOM from 'react-dom'

const createBounceLoader = (mainColor, fadedColor, offset = '17px') => keyframes`
  0% {
    box-shadow: ${offset} 0 ${mainColor}, -${offset} 0 ${fadedColor};
    background: ${mainColor};
  }
  33% {
    box-shadow: ${offset} 0 ${mainColor}, -${offset} 0 ${fadedColor};
    background: ${fadedColor};
  }
  66% {
    box-shadow: ${offset} 0 ${fadedColor}, -${offset} 0 ${mainColor};
    background: ${fadedColor};
  }
  100% {
    box-shadow: ${offset} 0 ${fadedColor}, -${offset} 0 ${mainColor};
    background: ${mainColor};
  }
`

export const DotsLoader = styled.div.attrs({
  role: 'status',
  'aria-label': 'Loading'
})`
  width: 12px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: ${({ mainColor, fadedColor, theme }) =>
    createBounceLoader(
      mainColor || theme?.loaderDot || '#000',
      fadedColor || theme?.loaderDotFaded || 'rgba(0,0,0,0.125)'
    )} 0.75s infinite linear alternate;
`

export const Loader = ({ sticky, zIndex = null }) => {
  const reactRoot = document.getElementById('react')

  if (sticky) return <Loading sticky={sticky} zIndex={zIndex} />
  return ReactDOM.createPortal(<Loading />, reactRoot)
}

const LoadingPageProgress = keyframes`
  0%{
    background-position: 0 0;
  }
  100%{
    background-position:-200% 0;
  }
`

const Loading = styled.div`
  height: 2px;
  width: 100%;
  position: ${props => (props.sticky ? 'sticky' : 'fixed')};
  overflow: hidden;
  background: repeating-linear-gradient(
    to right,
    ${props => props.theme.primary} 0%,
    ${props => props.theme.orange} 50%,
    ${props => props.theme.primary} 100%
  );
  top: 0px;
  left: 0px;
  right: 0px;
  animation: ${LoadingPageProgress} 2s infinite;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  background-size: 200% auto;
  background-position: 0 100%;
  z-index: ${props => (props.zIndex ? props.zIndex : '9999')};
`
